import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  constructor(private http: HttpClient, private restService: RestService) {}

  modulesSystem(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config', val_params);
  }
}
